export default __webpack_public_path__ + "static/media/pp.09e33050.png";